import {createEmployeeConfig} from 'main/content/hr/createEmployee/createEmployeeConfig';
import {ViewEmployeeConfig} from 'main/content/hr/viewEmployee/ViewEmployeeConfig';
import {testingConfig} from 'main/content/hr/testing/testingConfig';
import {SystemSettingConfig} from 'main/content/hr/systemSetting/SystemSettingConfig';

export const hrConfigs = [
    createEmployeeConfig,
    ViewEmployeeConfig ,
    testingConfig,
    SystemSettingConfig
];


// WEBPACK FOOTER //
// ./src/main/content/hr/hrConfigs.js